import { Type } from "@angular/core";
import {
  EXPORT_REPORT_ROUTES,
  EXPORT_REPORT_TYPES,
  ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS,
  ONBOARDING_CANDIDATE_CLAIMS_FOUND_ROUTE,
  WEBSOCKET_EVENT_TYPES,
  BellNotificationEventType,
} from "../../constants/websocket-event-types.constants";
import { WebSocketMessage } from "../../services/websocket.service";
import { NotificationDispatchContext } from "./app-notification.model";
import { NotificationItemExportCompleteComponent } from "./notification-items/notification-item-export-complete/notification-item-export-complete.component";
import { NotificationItemOnboardingCasesComponent } from "./notification-items/notification-item-onboarding-cases/notification-item-onboarding-cases.component";
import { buildOnboardingPotentialCasesMessage } from "./onboarding-notification.helper";

export interface NotificationRegistryEntry {
  component: Type<unknown>;
  /** i18n key suffix for toast on receive (export-complete). */
  toastKey?: string;
  /** Builds toast text on receive (onboarding). */
  getToastMessage?: (payload: WebSocketMessage) => string;
  acceptMessage?: (message: WebSocketMessage) => boolean;
  onReceived?: (
    message: WebSocketMessage,
    context: NotificationDispatchContext,
  ) => void;
}

export const NOTIFICATION_REGISTRY: Record<
  BellNotificationEventType,
  NotificationRegistryEntry
> = {
  [WEBSOCKET_EVENT_TYPES.EXPORT_COMPLETE]: {
    component: NotificationItemExportCompleteComponent,
    toastKey: "report_ready",
    acceptMessage: (message) => {
      const reportType = message["reportType"];
      return (
        typeof reportType === "string" && reportType in EXPORT_REPORT_ROUTES
      );
    },
  },
  [WEBSOCKET_EVENT_TYPES.ONBOARDING_POTENTIAL_CASES_COMPLETED]: {
    component: NotificationItemOnboardingCasesComponent,
    getToastMessage: (payload) => buildOnboardingPotentialCasesMessage(payload),
  },
};

export function getNotificationRegistryEntry(
  eventType: string,
): NotificationRegistryEntry | undefined {
  return NOTIFICATION_REGISTRY[eventType as BellNotificationEventType];
}

export function navigateToOnboardingCandidateClaims(
  storeId: string,
  context: NotificationDispatchContext,
): void {
  context.navigate(ONBOARDING_CANDIDATE_CLAIMS_FOUND_ROUTE, {
    [ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS.CLAIM_FOUND]: "true",
    [ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS.STORE_ID]: storeId,
  });
}

/** Report type slugs accepted by export-complete notifications. */
export const EXPORT_COMPLETE_REPORT_TYPES = Object.values(EXPORT_REPORT_TYPES);
